import { render, staticRenderFns } from "./EModalBnccFranquia.vue?vue&type=template&id=fad6d8e8&scoped=true"
import script from "./EModalBnccFranquia.vue?vue&type=script&lang=js"
export * from "./EModalBnccFranquia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad6d8e8",
  null
  
)

export default component.exports